import { all } from 'redux-saga/effects';
import { saga as UserSaga } from './UserSaga';
import { saga as SearchUsersSaga } from './SearchUsersSaga';
import { saga as ProfileSaga } from './ProfileSaga';
import { saga as LeaderboardsSaga } from './LeaderboardsSaga';
import { saga as BreakdownSaga } from './BreakDownSaga';
import { saga as WorkoutSaga } from './WorkoutSaga';
import { saga as SearchWorkoutsSaga } from './SearchWorkoutsSaga';
import { saga as MetaSaga } from './MetaSaga';
import { saga as ClassesSaga } from './ClassesSaga';
import { saga as ExercisesSaga } from './ExercisesSaga';
import { saga as BookedUsersSaga } from './BookedUsersSaga';
import { saga as MembershipPlansSaga } from './MembershipPlansSaga';
import { saga as MembersSaga } from './MembersSaga';
import { saga as GymTvSaga } from './GymTvSaga';
import { saga as ActivitySaga } from './ActivitySaga';

export function* sagas() {
    yield all([
        UserSaga(),
        SearchUsersSaga(),
        ProfileSaga(),
        ActivitySaga(),
        LeaderboardsSaga(),
        BreakdownSaga(),
        WorkoutSaga(),
        SearchWorkoutsSaga(),
        MetaSaga(),
        ClassesSaga(),
        ExercisesSaga(),
        BookedUsersSaga(),
        MembershipPlansSaga(),
        MembersSaga(),
        GymTvSaga(),
    ]);
}



// WEBPACK FOOTER //
// ./src/Store/Saga/index.js